export const productReducer = (state = {}, action) => {
  switch (action.type) {
    case 'PRODUCT_DETAILS':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const typeFilterReducer = (state = 'imovel', action) => {
  switch (action.type) {
    case 'SET_TYPE_FILTER':
      return action.payload;
    default:
      return state;
  }
};
